import { useAuth } from "duck";
import { useGetAllowedUsersCountQuery } from "requests";

export const useAllowedUsersCount = () => {
  const [{ user }] = useAuth();
  const { data, loading, refetch } = useGetAllowedUsersCountQuery({
    variables: { id: user._id },
    fetchPolicy: "no-cache"
  });

  const maxCount =
    data?.user?.organization?.order?.license.maxNumberOfUsers || 0;
  const currentCount = data?.users?.paginationInfo.totalCount || 0;

  return {
    loading,
    refetch,
    maxCount,
    allowed: maxCount > currentCount
  };
};
